module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0088.png.da41df11.jpg";